// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MA6e","toggle":"styles_toggle__2HugV","preview":"styles_preview__1wyJd"};